<div class="container {{buttonClass}} {{borderClass}}"
     (mousedown)="onEvent($event, 'down'); buttonState = true"
     (mouseup)="onEvent($event, 'up'); buttonState = false"
     (mouseleave)="onEvent($event, 'leave')"
     [@pressState]="buttonState && !disabled  ? 'down' : 'up'"
     [class.disabled]="disabled"
     [ngStyle]="styleInline"
     type="submit"
     (click)="onEvent($event, 'click')"
     [id]="buttonId"
>
    <img class="left-icon" [ngClass]="{'only-icon': !!text}" [src]="icon" alt="left icon" *ngIf="!!icon && iconDirection === 'left'"/>
    <div class="text"  *ngIf="!!text">{{ text }}</div>
    <img class="right-icon" [ngClass]="{'only-icon': !!text}" [src]="icon" alt="right icon" *ngIf="icon && iconDirection === 'right'"/>
    <div class="right-icon" [ngClass]="{'only-icon': !!text}" *ngIf="rightTemplate">
        <ng-container *ngTemplateOutlet="rightTemplate"></ng-container>
    </div>
</div>
